/**
 * Sólo se elimina un borrador que nunca se envió a aprobación. El servidor es
 * quien decide de verdad (y responde 409 si no); esto sólo evita ofrecer el botón.
 * Una en «ajuste solicitado» ya pasó por aprobación, aunque su estado sea de borrador.
 */
export function sePuedeEliminar(q: {
  status: string;
  firstSubmittedAt: string | null;
  submittedAt: string | null;
}): boolean {
  return q.status === 'DRAFT' && q.firstSubmittedAt === null && q.submittedAt === null;
}
